
import {
  resultToFailed, resultToSuccess
} from '../Helper'
import stockApi from '../StockApi'

export const getSuppliers = async () => {
  try {
    const responseSuccess = await stockApi.get('/fornecedores')
    return resultToSuccess(responseSuccess)
  } catch (responseFailed) {
    throw resultToFailed(responseFailed)
  }
}
